export default {
  name: 'import-csv-batch',
  translationKey: 'import-csv-batch-module',
  routePrefix: 'csv-batch',
  routeNamePrefix: 'csv-batch',
  directRoutesAvailable: true,
}
